import {
  collectionSearchApi,
  advertiseCollectionApi,
} from '@/entities/collection';
import { convertCollectionListItem } from '@/shared/utils';

export const getTrendingCollections = async () => {
  const [
    recommendedCollectionsData,
    advertiseCollectionData1,
    advertiseCollectionData2,
  ] = await Promise.all([
    collectionSearchApi({ ordering: 'landing_popular' }),
    advertiseCollectionApi({ location: 'hot_1' }),
    advertiseCollectionApi({ location: 'hot_2' }),
  ]);

  const recommendedCollections = recommendedCollectionsData.data.results;
  const advertiseCollections = [
    advertiseCollectionData1.data.collection,
    advertiseCollectionData2.data.collection,
  ];

  const collections = convertCollectionListItem([
    ...recommendedCollections.slice(0, 3),
    advertiseCollections[0],
    ...recommendedCollections.slice(3, 6),
    advertiseCollections[1],
  ]).map((collection) => ({
    ...collection,
    scrapsLength: collection.scraps.length,
    isAdvertisement: advertiseCollections
      .map((advertiseCollection) => advertiseCollection.id)
      .includes(collection.id),
  }));

  return collections;
};
